import React from 'react';
import PropTypes from 'prop-types';
import TextQuestionComponent from './TextQuestionComponent';
import {
  HOUSE_NAME,
  STREET_NAME,
  AREA_NAME,
  CITY_NAME,
  BUILDING_NO,
  FLAT_NO,
  POST_CODE,
  COUNTY
} from '../addressUtils/addressConstants';

const LocalAddressComponent = ({ type }) => (
  <div>
    <TextQuestionComponent
      type={`${type}.local`}
      name={FLAT_NO}
      label={FLAT_NO}
      labelError="FlatNumberError"
      columnWidth={1}
      optionalField={true}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={BUILDING_NO}
      label={BUILDING_NO}
      labelError="BuildingNumberError"
      columnWidth={1}
      optionalField={false}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={HOUSE_NAME}
      label={HOUSE_NAME}
      labelError="HouseNameError"
      columnWidth={3}
      optionalField={false}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={STREET_NAME}
      label={STREET_NAME}
      labelError="StreetNameError"
      columnWidth={6}
      optionalField={true}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={AREA_NAME}
      label={AREA_NAME}
      labelError="AreaNameError"
      columnWidth={3}
      optionalField={true}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={CITY_NAME}
      label={CITY_NAME}
      labelError="CityNameError"
      columnWidth={3}
      optionalField={true}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name="postcode"
      label={`${POST_CODE}`}
      labelError="PostCodeError"
      columnWidth={3}
      optionalField={true}
    />
    <TextQuestionComponent
      type={`${type}.local`}
      name={COUNTY}
      label={COUNTY}
      labelError="CountyError"
      columnWidth={3}
      optionalField={true}
    />
  </div>
);

LocalAddressComponent.propTypes = {
  type: PropTypes.string.isRequired
};

export default LocalAddressComponent;
